import React from 'react';
import { FadeIn } from './FadeIn';
import { QuoteIcon } from 'lucide-react';
export function StorySection() {
  return <section className="bg-bakery-tan py-24 px-6 relative overflow-hidden" data-id="element-160">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-bakery-amber/30 to-transparent" data-id="element-161"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-bakery-amber/30 to-transparent" data-id="element-162"></div>

      <div className="max-w-4xl mx-auto" data-id="element-163">
        <FadeIn data-id="element-164">
          <div className="bg-bakery-cream p-8 md:p-12 rounded-2xl shadow-xl shadow-bakery-brown/5 relative" data-id="element-165">
            <QuoteIcon className="absolute top-6 left-6 w-12 h-12 text-bakery-amber/20" data-id="element-166" />

            <div className="relative z-10" data-id="element-167">
              <h3 className="text-3xl font-serif font-bold text-bakery-brown mb-6" data-id="element-168">
                La historia detrás del manual
              </h3>

              <div className="space-y-6 text-lg text-bakery-brown/80 leading-relaxed" data-id="element-169">
                <p data-id="element-170">
                  <strong className="text-bakery-brown" data-id="element-171">
                    Hola, soy Marines Rosales.
                  </strong>{' '}
                  Durante años viví frustrada porque el pan nunca me salía bien.
                  La masa me quedaba dura, seca y sin vida. Sentía que "no tenía
                  mano" para la cocina y terminé resignada a comer pan
                  industrial.
                </p>
                <p data-id="element-172">
                  Todo cambió cuando entendí que el secreto no es el talento,
                  sino la precisión. Descubrí que una "taza" de harina puede
                  variar hasta 40 gramos dependiendo de quién la llene, y ese
                  pequeño error es el que arruina tu pan.
                </p>
                <p className="font-medium text-bakery-brown text-xl italic" data-id="element-173">
                  Cuando eliminé las tazas y empecé a usar los gramos exactos,
                  la magia ocurrió.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}